import { CorvalBusinessFunction, CorvalColor, CorvalCompletionState, CorvalCriticality, CorvalMilestone, CorvalProject, CorvalProjectVersion, CorvalProjectVersionMilestone, CorvalUIColor, IEntityColorDefintion, IEntityIconDefintion, SemanticUIColor } from '../types';
import { SemanticICONS }                                                                                                                                                                                                                                   from 'semantic-ui-react';


export const ENTITY_ICONS: IEntityIconDefintion = {
    SYSTEM:             {
        SETTINGS: 'cog',
        SUPPORT:  'comment alternate outline',
    },
    QUESTIONS:          {
        CORE:     'list alternate',
        ADDITIVE: 'tasks',
        PROJECT:  'folder outline',
    },
    DATA_VALUE_SETS:    'list',
    MILESTONES:         {
        ENTITY: 'calendar outline',
        ITEM:   'square',
    },
    ASSUMPTIONS:        {
        ENTITY: 'clipboard outline',
        GROUPS: 'list alternate',
    },
    OBJECTIVES:         {
        GROUPS: 'object group',
    },
    SUBOBJECTIVES:      {
        ENTITY:        'bullseye',
        VISUALIZATION: 'map outline',
        STATUS:        'check circle',
        STATUSES:      {
            NOT_STARTED:      'circle outline',
            IN_PROGRESS_LOW:  'dot circle outline',
            IN_PROGRESS_MED:  'dot circle outline',
            IN_PROGRESS_HIGH: 'dot circle outline',
            COMPLETE:         'check circle',
        }
    },
    ACTIVITIES:         {
        ENTITY:              'lightning',
        VISUALIZATION_GRID:  'list layout',
        VISUALIZATION_GANTT: 'signal',
        RECURRENCE:          'redo',
        RISK_RATING:         'asterisk',
        RISKS:               {
            LATE_COMPLETION: 'clock outline',
            AT_RISK:         'warning sign',
            NONE:            'ban',
        },
        STATUS:              'check circle outline',
        STATUSES:            {
            NOTSTARTED: 'circle outline',
            INCOMPLETE: 'dot circle outline',
            COMPLETE:   'check circle',
            EXCLUDED:   'eye slash',
        },
        TIMING:              {
            EARLY:  'paper plane outline',
            NORMAL: 'clock',
            LATE:   'clock outline',
        },
        CRITICALITY_RATING:  'dot circle',
        CRITICALITY:         {
            CRITICAL: 'warning circle',
            PRIORITY: 'star',
            MODERATE: 'angle double up',
            MINOR:    'angle up',
        }
    },
    USER:               {
        ENTITY:   'user',
        WATCHER:  'user circle outline',
        RESOURCE: 'user circle outline',
        LOGOUT:   'sign-out',
    },
    USER_ROLES:         {
        SYSTEM:         {
            CORVALADMIN:         'user circle',
            ACCOUNTSADMIN:       'user circle',
            DECISIONENGINEADMIN: 'user circle',
            MEMBER:              'user circle outline',
        },
        ORGANIZATIONAL: {
            ADMIN:  'user circle',
            MEMBER: 'user circle outline',
        },
        PROJECT:        {
            ADMIN:  'user circle',
            MEMBER: 'user circle outline',
            VIEWER: 'user circle outline',
        }
    },
    PROJECTS:           {
        ENTITY:             'briefcase',
        SUBSCRIPTION_TYPES: {
            FREEUNLIMITED: 'briefcase'
        },
        TEMPLATES:          {
            ENTITY: 'clone',
            TYPES:  {
                FULLY_PACKAGED:   'briefcase',
                GLOBALLY_FOCUSED: 'globe',
                RESOURCE_FOCUSED: 'group',
                BUDGET_FOCUSED:   'usd',
                TACTICAL:         'tasks',
                PRECISION:        'bullseye',
                STRUCTURED:       'sitemap',
                TIME_SENSITIVE:   'clock outline',
                TARGETED:         'crosshairs',
                EXPERIMENTAL:     'cogs',
                LOCKED:           'lock',
                DO_NOT_USE:       'ban',
            }
        }
    },
    BUSINESS_FUNCTIONS: {
        ENTITY: 'cube'
    },
    CATEGORIES:         {
        ENTITY:     'tag',
        GENERIC:    'tasks',
        INTERNAL:   'building',
        FIELD:      'users',
        OPERATIONS: 'cogs',
    },
    BUDGET:             {
        REPORTING:               'chart bar',
        ENTITY_CATEGORICAL:      'cubes',
        ENTITY_HIRING:           'users',
        ENTITY:                  'dollar sign',
        FEE_COSTS:               'dollar sign',
        OPERATIONAL_COSTS:       'building',
        SCHEDULED_COSTS:         'building',
        ONGOING_COSTS:           'refresh',
        HIRING_COSTS:            'user',
        RECURRENCE_COSTS:        'redo',
        CUSTOM_DATA_CATEGORICAL: 'cube',
        CUSTOM_DATA_HIRING:      'user',
        DATE_RANGE:              'calendar alternate outline',
    },
    META:               {
        TAG:   'tag',
        LINKS: 'linkify',
    },
    RESOURCING:         {
        HIRES: {
            ENTITY: 'user circle'
        }
    }
}

export const ENTITY_COLORIZATION: IEntityColorDefintion = {
    ACTIVITIES: {
        TIMING:      {
            EARLY:  SemanticUIColor.GREEN,
            NORMAL: SemanticUIColor.GREY,
            LATE:   SemanticUIColor.RED,
        },
        CRITICALITY: {
            CRITICAL: SemanticUIColor.RED,
            PRIORITY: SemanticUIColor.VIOLET,
            MODERATE: SemanticUIColor.BLACK,
            MINOR:    SemanticUIColor.GREY,
        },
        RISKS:       {
            LATE_COMPLETION: SemanticUIColor.RED,
            AT_RISK:         SemanticUIColor.ORANGE,
            NONE:            SemanticUIColor.GREY,
        },
    },
    CATEGORIES: {
        GENERIC:    CorvalUIColor.LIGHTBRINE,
        INTERNAL:   SemanticUIColor.BLUE,
        FIELD:      SemanticUIColor.TEAL,
        OPERATIONS: SemanticUIColor.PURPLE,
    },
    MILESTONES: {
        DEFAULT: SemanticUIColor.RED
    }
}

export enum INTAKE_QUESTION_CONTEXTS {
    CORE     = 'CORE',
    ADDITIVE = 'ADDITIVE',
    PROJECT  = 'PROJECT',
}

export const INTAKE_QUESTION_CONTEXT_INFO = {
    CORE:     {
        LABEL:       'INTAKE_QUESTION_CONTEXTS.CORE.LABEL',
        DESCRIPTION: 'INTAKE_QUESTION_CONTEXTS.CORE.DESCRIPTION',
        ICON:        'list alternate',
    },
    ADDITIVE: {
        LABEL:       'INTAKE_QUESTION_CONTEXTS.ADDITIVE.LABEL',
        DESCRIPTION: 'INTAKE_QUESTION_CONTEXTS.ADDITIVE.DESCRIPTION',
        ICON:        'tasks',
    },
    PROJECT:  {
        LABEL:       'INTAKE_QUESTION_CONTEXTS.PROJECT.LABEL',
        DESCRIPTION: 'INTAKE_QUESTION_CONTEXTS.PROJECT.DESCRIPTION',
        ICON:        'folder outline',
    },
};

export const OBJECTIVE_FILTERS = {
    CONDITION_TYPES: {
        ALL:         'ALL',
        GENERALIZED: 'GENERALIZED',
        CONDITIONAL: 'CONDITIONAL',
    },
};

export enum SYSTEM_ROLES {
    CORVALADMIN         = 'CORVALADMIN',
    ACCOUNTSADMIN       = 'ACCOUNTSADMIN',
    DECISIONENGINEADMIN = 'DECISIONENGINEADMIN',
    MEMBER              = 'MEMBER'
}

export const SYSTEM_ROLE_INFO = {
    [ SYSTEM_ROLES.CORVALADMIN ]:         {
        LABEL: 'SYSTEM_ROLES.CORVALADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.SYSTEM.CORVALADMIN,
    },
    [ SYSTEM_ROLES.ACCOUNTSADMIN ]:       {
        LABEL: 'SYSTEM_ROLES.ACCOUNTSADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.SYSTEM.ACCOUNTSADMIN,
    },
    [ SYSTEM_ROLES.DECISIONENGINEADMIN ]: {
        LABEL: 'SYSTEM_ROLES.DECISIONENGINEADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.SYSTEM.DECISIONENGINEADMIN,
    },
    [ SYSTEM_ROLES.MEMBER ]:              {
        LABEL: 'SYSTEM_ROLES.MEMBER.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.SYSTEM.MEMBER,
    },
};

export enum ORGANIZATIONAL_ROLES {
    ADMIN  = 'ADMIN',
    MEMBER = 'MEMBER',
}

export const ORGANIZATIONAL_ROLE_INFO = {
    [ ORGANIZATIONAL_ROLES.ADMIN ]:  {
        LABEL: 'ORGANIZATIONAL_ROLES.ADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.ORGANIZATIONAL.ADMIN,
    },
    [ ORGANIZATIONAL_ROLES.MEMBER ]: {
        LABEL: 'ORGANIZATIONAL_ROLES.MEMBER.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.ORGANIZATIONAL.MEMBER,
    },
};

export enum PROJECT_ROLES {
    ADMIN  = 'ADMIN',
    MEMBER = 'MEMBER',
    VIEWER = 'VIEWER',
}

export const PROJECT_ROLE_INFO = {
    [ PROJECT_ROLES.ADMIN ]:  {
        LABEL: 'PROJECT_ROLES.ADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.PROJECT.ADMIN,
    },
    [ PROJECT_ROLES.MEMBER ]: {
        LABEL: 'PROJECT_ROLES.MEMBER.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.PROJECT.MEMBER,
    },
    [ PROJECT_ROLES.VIEWER ]: {
        LABEL: 'PROJECT_ROLES.VIEWER.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.PROJECT.VIEWER,
    },
};

export enum SUBSCRIPTION_TYPES {
    FREEUNLIMITED = 'FREEUNLIMITED',
}

export const SUBSCRIPTION_TYPE_INFO = {
    [ SUBSCRIPTION_TYPES.FREEUNLIMITED ]: {
        LABEL: 'Free Unlimited',
        ICON:  ENTITY_ICONS.PROJECTS.SUBSCRIPTION_TYPES.FREEUNLIMITED,
    },
};

/* These are functions of a project, and must match the project model */
export type ProjectDetailField = keyof Pick<CorvalProject,
    'name'
    | 'assetName'
    | 'assetIndication'>;

export type ProjectVersionDetailField = keyof Pick<CorvalProjectVersion,
    'id'
    | 'name'
    | 'description'
    | 'isDefaultVersion'
    | 'isActiveVersion'
    | 'isImmutableBase'
    | 'createdUtc'
    | 'createdById'
    | 'updatedUtc'
    | 'updatedById'>;

export type ProjectMilestoneField = keyof Pick<CorvalMilestone,
    'id'
    | 'name'
    | 'description'
    | 'colorValue'
    | 'iconName'
    | 'resourceCode'
    | 'refIdCode'
    | 'isArchived'>;

export type ProjectVersionMilestoneField = keyof Pick<CorvalProjectVersionMilestone,
    'id'
    | 'name'
    | 'description'
    | 'milestoneId'
    | 'milestoneDate'
    | 'colorValue'
    | 'iconName'>;

export type ProjectBusinessFunctionField = keyof Pick<CorvalBusinessFunction,
    'id'
    | 'name'
    | 'description'
    | 'colorValue'
    | 'iconName'
    | 'resourceCode'
    | 'refIdCode'
    | 'isArchived'>;

export type ProjectVersionMilestonesField = 'projectVersionMilestones';

export enum TimelineDataObjectType {
    PROJECT_MILESTONE,
    GENERIC_DATE,
    CURRENT_DATE,
}

export const projectDetailFields: ProjectDetailField[] = [
    'name',
];

export const projectDescFields: ProjectDetailField[] = [
    'assetName',
    'assetIndication',
];

export const projectVersionDetailFields: ProjectVersionDetailField[] = [
    'id',
    'name',
    'description',
    'isDefaultVersion',
    'isActiveVersion',
    'isImmutableBase',
    'createdUtc',
    'createdById',
    'updatedUtc',
    'updatedById',
];

export const projectVersionMilestoneFields: ProjectVersionMilestoneField[] = [
    'id',
    'name',
    'description',
    'milestoneId',
    'milestoneDate',
    'colorValue',
    'iconName',
];

export const projectMilestoneFields: ProjectBusinessFunctionField[] = [
    'id',
    'name',
    'description',
    'colorValue',
    'iconName',
    'resourceCode',
    'refIdCode',
    'isArchived',
];

export const projectBusinessFunctionFields: ProjectBusinessFunctionField[] = [
    'id',
    'name',
    'description',
    'colorValue',
    'iconName',
    'resourceCode',
    'refIdCode',
    'isArchived',
];

export enum PROJECT_DESC_FIELDS {
    NAME             = 'NAME',
    ASSET_NAME       = 'ASSET_NAME',
    ASSET_INDICATION = 'ASSET_INDICATION',
}

type ProjectDetailInfoItem = {
    LABEL: string,
    DESCRIPTION: string,
    PROJECT_FIELD: ProjectDetailField,
}

export const PROJECT_DESCRIPTION_INFO: Record<any, ProjectDetailInfoItem> = {

    NAME:             {
        LABEL:         'PROJECT_DETAILS.NAME.LABEL',
        DESCRIPTION:   'PROJECT_DETAILS.NAME.DESCRIPTION',
        PROJECT_FIELD: 'name',
    },
    ASSET_NAME:       {
        LABEL:         'PROJECT_DETAILS.ASSET_NAME.LABEL',
        DESCRIPTION:   'PROJECT_DETAILS.ASSET_NAME.DESCRIPTION',
        PROJECT_FIELD: 'assetName',
    },
    ASSET_INDICATION: {
        LABEL:         'PROJECT_DETAILS.ASSET_INDICATION.LABEL',
        DESCRIPTION:   'PROJECT_DETAILS.ASSET_INDICATION.DESCRIPTION',
        PROJECT_FIELD: 'assetIndication',
    }
};

export const PROJECT_ENTITY_SUPPORTED_COLORS = [

    CorvalUIColor.LIGHTBLUE,
    SemanticUIColor.BLUE,
    CorvalUIColor.DARKBLUE,

    CorvalUIColor.LIGHTBRINE,
    CorvalUIColor.BRINE,
    CorvalUIColor.DARKBRINE,

    CorvalUIColor.LIGHTGREEN,
    SemanticUIColor.GREEN,
    CorvalUIColor.DARKGREEN,

    CorvalUIColor.LIGHTORANGE,
    SemanticUIColor.ORANGE,
    CorvalUIColor.DARKORANGE,

    CorvalUIColor.LIGHTPINK,
    SemanticUIColor.PINK,
    CorvalUIColor.DARKPINK,

    CorvalUIColor.LIGHTPURPLE,
    SemanticUIColor.PURPLE,
    CorvalUIColor.DARKPURPLE,

    CorvalUIColor.LIGHTRED,
    SemanticUIColor.RED,
    CorvalUIColor.DARKRED,

    CorvalUIColor.LIGHTTEAL,
    SemanticUIColor.TEAL,
    CorvalUIColor.DARKTEAL,

    CorvalUIColor.LIGHTYELLOW,
    SemanticUIColor.YELLOW,
    CorvalUIColor.DARKYELLOW,

    CorvalUIColor.GREY,
    CorvalUIColor.DARKGREY,
    SemanticUIColor.BLACK,
];

export const PROJECT_ENTITY_SUPPORTED_ICON_NAMES: SemanticICONS[] = [
    'globe',
    'industry',
    'building outline',
    'hospital outline',
    'warehouse',
    'chart bar outline',
    'chart line',
    'pie chart',
    'book',
    'certificate',
    'clipboard outline',
    'compass outline',
    'copyright outline',
    'registered outline',
    'phone',
    'archive',
    'code',
    'microchip',
    'address card outline',
    'bullhorn',
    'server',
    'tint',
    'paint brush',
    'film',
    'pencil',
    'handshake outline',
    'user outline',
    'user md',
    'barcode',
    'shipping fast',
    'balance scale',
    'flask',
    'key',
    'leaf',
    'money',
    'dollar sign',
    'euro sign',
    'yen sign',
    'pound sign',
];

export type EnumDescriptorType = {
    VALUE: string | number,
    LABEL: string,
    DESCRIPTION: string,
    COLOR: SemanticUIColor | CorvalUIColor,
    ICON?: SemanticICONS,
}

//@ts-ignore
export type EnumDescriptorTypeSet<D> = Record<D, EnumDescriptorType>;

export type ActivityCriticalityField = 'CRITICAL' | 'PRIORITY' | 'MODERATE' | 'MINOR';

export type ActivityCriticalityType = ACTIVITY_CRITICALITY | CorvalCriticality

/* Budget impact levels */
export type ActivityCriticalityTypeSet = EnumDescriptorTypeSet<ActivityCriticalityField>

/* These are the currently assigned values of an activity in the DEM, with descriptions */
export enum ACTIVITY_CRITICALITY {
    CRITICAL = 'CRITICAL',
    PRIORITY = 'PRIORITY',
    MODERATE = 'MODERATE',
    MINOR    = 'MINOR',
}

export const ACTIVITY_CRITICALITY_INFO: ActivityCriticalityTypeSet = {
    CRITICAL: {
        VALUE:       'CRITICAL',
        LABEL:       'ACTIVITY_CRITICALITY.CRITICAL.LABEL',
        DESCRIPTION: 'ACTIVITY_CRITICALITY.CRITICAL.DESCRIPTION',
        COLOR:       ENTITY_COLORIZATION.ACTIVITIES.CRITICALITY.CRITICAL,
        ICON:        ENTITY_ICONS.ACTIVITIES.CRITICALITY.CRITICAL,
    },
    PRIORITY: {
        VALUE:       'PRIORITY',
        LABEL:       'ACTIVITY_CRITICALITY.PRIORITY.LABEL',
        DESCRIPTION: 'ACTIVITY_CRITICALITY.PRIORITY.DESCRIPTION',
        COLOR:       ENTITY_COLORIZATION.ACTIVITIES.CRITICALITY.PRIORITY,
        ICON:        ENTITY_ICONS.ACTIVITIES.CRITICALITY.PRIORITY,
    },
    MODERATE: {
        VALUE:       'MODERATE',
        LABEL:       'ACTIVITY_CRITICALITY.MODERATE.LABEL',
        DESCRIPTION: 'ACTIVITY_CRITICALITY.MODERATE.DESCRIPTION',
        COLOR:       ENTITY_COLORIZATION.ACTIVITIES.CRITICALITY.MODERATE,
        ICON:        ENTITY_ICONS.ACTIVITIES.CRITICALITY.MODERATE,
    },
    MINOR:    {
        VALUE:       'MINOR',
        LABEL:       'ACTIVITY_CRITICALITY.MINOR.LABEL',
        DESCRIPTION: 'ACTIVITY_CRITICALITY.MINOR.DESCRIPTION',
        COLOR:       ENTITY_COLORIZATION.ACTIVITIES.CRITICALITY.MINOR,
        ICON:        ENTITY_ICONS.ACTIVITIES.CRITICALITY.MINOR,
    },
}

export type ActivityStatusField = 'NOTSTARTED' | 'INCOMPLETE' | 'COMPLETE' | 'EXCLUDED'
export type ActivityStatusType = ACTIVITY_STATUS | CorvalCompletionState;
export type ActivityStatusTypeSet = EnumDescriptorTypeSet<ActivityStatusField>

export enum ACTIVITY_STATUS {
    NOTSTARTED = CorvalCompletionState[ 'Notstarted' ],
    INCOMPLETE = CorvalCompletionState[ 'Incomplete' ],
    COMPLETE   = CorvalCompletionState[ 'Complete' ],
    EXCLUDED   = CorvalCompletionState[ 'Excluded' ],
}

export const ACTIVITY_STATUS_INFO: ActivityStatusTypeSet = {
    NOTSTARTED: {
        VALUE:       'NOTSTARTED',
        LABEL:       'ACTIVITY_STATUSES.NOTSTARTED.LABEL',
        DESCRIPTION: 'ACTIVITY_STATUSES.NOTSTARTED.DESCRIPTION',
        COLOR:       SemanticUIColor.PURPLE,
        ICON:        ENTITY_ICONS.ACTIVITIES.STATUSES.NOTSTARTED,
    },
    INCOMPLETE: {
        VALUE:       'INCOMPLETE',
        LABEL:       'ACTIVITY_STATUSES.INCOMPLETE.LABEL',
        DESCRIPTION: 'ACTIVITY_STATUSES.INCOMPLETE.DESCRIPTION',
        COLOR:       SemanticUIColor.TEAL,
        ICON:        ENTITY_ICONS.ACTIVITIES.STATUSES.INCOMPLETE,
    },
    COMPLETE:   {
        VALUE:       'COMPLETE',
        LABEL:       'ACTIVITY_STATUSES.COMPLETE.LABEL',
        DESCRIPTION: 'ACTIVITY_STATUSES.COMPLETE.DESCRIPTION',
        COLOR:       SemanticUIColor.GREEN,
        ICON:        ENTITY_ICONS.ACTIVITIES.STATUSES.COMPLETE,
    },
    EXCLUDED:   {
        VALUE:       'EXCLUDED',
        LABEL:       'ACTIVITY_STATUSES.EXCLUDED.LABEL',
        DESCRIPTION: 'ACTIVITY_STATUSES.EXCLUDED.DESCRIPTION',
        COLOR:       SemanticUIColor.GREY,
        ICON:        ENTITY_ICONS.ACTIVITIES.STATUSES.EXCLUDED,
    },
}

export enum OBJECTIVE_STATUS {
    NOT_STARTED      = 'NOT_STARTED',
    IN_PROGRESS_LOW  = 'IN_PROGRESS_LOW',
    IN_PROGRESS_MED  = 'IN_PROGRESS_MED',
    IN_PROGRESS_HIGH = 'IN_PROGRESS_HIGH',
    COMPLETE         = 'COMPLETE'
}

export type ObjectiveStatusField = 'NOT_STARTED' | 'IN_PROGRESS_LOW' | 'IN_PROGRESS_MED' | 'IN_PROGRESS_HIGH' | 'COMPLETE'
export type ObjectiveStatusType = OBJECTIVE_STATUS;
export type ObjectiveStatusTypeSet = EnumDescriptorTypeSet<ObjectiveStatusField>
export const OBJECTIVE_STATUS_INFO: ObjectiveStatusTypeSet = {
    NOT_STARTED:      {
        VALUE:       'NOT_STARTED',
        LABEL:       'OBJECTIVE_STATUSES.NOT_STARTED.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.NOT_STARTED.DESCRIPTION',
        COLOR:       SemanticUIColor.GREY,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.NOT_STARTED,
    },
    IN_PROGRESS_LOW:  {
        VALUE:       'IN_PROGRESS_LOW',
        LABEL:       'OBJECTIVE_STATUSES.IN_PROGRESS_LOW.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.IN_PROGRESS_LOW.DESCRIPTION',
        COLOR:       SemanticUIColor.TEAL,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.IN_PROGRESS_LOW,
    },
    IN_PROGRESS_MED:  {
        VALUE:       'IN_PROGRESS_MED',
        LABEL:       'OBJECTIVE_STATUSES.IN_PROGRESS_MED.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.IN_PROGRESS_MED.DESCRIPTION',
        COLOR:       SemanticUIColor.TEAL,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.IN_PROGRESS_MED,
    },
    IN_PROGRESS_HIGH: {
        VALUE:       'IN_PROGRESS_HIGH',
        LABEL:       'OBJECTIVE_STATUSES.IN_PROGRESS_HIGH.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.IN_PROGRESS_HIGH.DESCRIPTION',
        COLOR:       SemanticUIColor.TEAL,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.IN_PROGRESS_HIGH,
    },
    COMPLETE:         {
        VALUE:       'COMPLETE',
        LABEL:       'OBJECTIVE_STATUSES.COMPLETE.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.COMPLETE.DESCRIPTION',
        COLOR:       SemanticUIColor.GREEN,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.COMPLETE,
    },
}

export enum SYSTEM_TEMPLATE_IDS {
    EMPTY_PROJECT   = "00000000-0000-0000-0000-000000000000",
    FULL_PROJECT_3Y = "00000000-0000-0000-0000-000000000003",
    FULL_PROJECT_5Y = "00000000-0000-0000-0000-000000000005",
}

export const SYSTEM_STRING_SIMILARITY_DEFAULT_THRESHOLD = 0.83;
